<style scoped lang="less">
  @import '../assets/css/less.less';
.app-selects{position: fixed; left: 0; top: 0; width: 100%; height: 100%; 
   background: rgba(255,255,255,0.95);
   .box; .box-frap; box-sizing: border-box; padding: 0 46/@r;
   align-content: center;
   z-index: 999;
}
.app-selects h1{ width: 100%; text-align: center; color: #2366af; font-size: 30/@r; font-weight: bold; padding-bottom: 30/@r;}
.app-select{width: 100%; .box; .box-frap; background: #fff;
border-left: 2/@r solid #ededed; border-top: 2/@r solid #ededed;
box-sizing: border-box;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.app-select p{  width: 33.3%; border-right: 2/@r solid #ededed; border-bottom: 2/@r solid #ededed;
  height: 84/@r; .box; font-size: 26/@r; color: #333333; box-sizing: border-box;text-align: center;
}
.app-select .p2{width: 50%;}
.app-select .pshow{ background: #b7dfff; color: #2366af;}

</style>
<template>
<div class="app-selects" v-if="isshow">
    <h1>{{title}}</h1>
    <div class="app-select">
         <p v-for="(item,idx) in arr" 
           :key="idx" 
           @touchstart="startFu" @touchmove="moveFu" @touchend="selectFu(item,idx)"
           :class="{pshow:idx == idxshow,p2:arr.length<3}"
         >{{item.text}}</p>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
            arr:[],
            isshow:false,
            start:0,
            idxshow:-1,
            callback:'',
            title:"",
        }
    },
    methods:{
        startFu(){this.start = 0;},
        moveFu(){this.start = 1;},
        selectFu(item,idx){
           if(this.start == 1){return;}
           this.callback && this.callback(item);
           this.endFu();
        },
        showFu({arr,id,title,callback}){
           this.callback = callback;
           this.title = title;
           this.arr = arr;
           if(id == -1){
               this.idxshow = id;  
           }else{
               this.arr.forEach((e,idx)=>{
                    if(e.value == id){
                        this.idxshow = idx;
                    }
                })
           }
           this.isshow = true;
        },
        endFu(){
           this.isshow = false;
        },
    }
}
</script>  


// WEBPACK FOOTER //
// src/components/infoSelect.vue